module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-image-3-800x533-837170a352ac0ee166c5e4deb0c7f05e.jpg";